import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import type { ItemLinkRelation } from '../../utils/item-field-sources';
import { BaseEntity } from './base.entity';

/**
 * PD-16509 — a link suggestion someone dismissed, so the catalog linking
 * screen stops offering it.
 *
 * One row per pair of items and relation (counterpart or variant), stored
 * with the smaller item id first so a pair dismissed from either side is the
 * same row. Dismissals are tenant-wide: two items one person decided are not
 * the same product are not the same product for anyone else either.
 * "Undo" soft-removes the row; dismissing again recovers it, keeping the
 * audit trail on one record.
 *
 * New table, created by the database sync; SM1 never names it.
 */
@Index(
	'uq_item_link_dismissal_pair',
	['fkItemIdFirst', 'fkItemIdSecond', 'relation'],
	{ unique: true },
)
@Index('idx_item_link_dismissal_second', ['fkItemIdSecond'], {})
@Entity('item_link_dismissal')
export class ItemLinkDismissalEntity extends BaseEntity {
	/** The pair's smaller item id. */
	@Column('int', { name: 'fk_item__id_first', unsigned: true })
	public fkItemIdFirst!: number;

	/** The pair's larger item id. */
	@Column('int', { name: 'fk_item__id_second', unsigned: true })
	public fkItemIdSecond!: number;

	@Column('varchar', { name: 'relation', length: 16 })
	public relation!: ItemLinkRelation;
}
